export type TdaTicketSummary = {
  mdTicketTypeId: string;
  requestedQuantity: number;
};

export const hasMatchingTdaVerification = (
  tdaTickets: TdaTicketSummary[],
  verifiedPassengers: { mdTicketTypeId: string }[],
) => {
  if (tdaTickets.length === 0) {
    return true;
  }

  const requestedSummary = new Map<string, number>();

  tdaTickets.forEach((ticket) => {
    requestedSummary.set(
      ticket.mdTicketTypeId,
      (requestedSummary.get(ticket.mdTicketTypeId) ?? 0) + ticket.requestedQuantity,
    );
  });

  const previousSummary = new Map<string, number>();

  verifiedPassengers.forEach((passenger) => {
    previousSummary.set(
      passenger.mdTicketTypeId,
      (previousSummary.get(passenger.mdTicketTypeId) ?? 0) + 1,
    );
  });

  if (requestedSummary.size !== previousSummary.size) {
    return false;
  }

  for (const [ticketTypeId, quantity] of requestedSummary.entries()) {
    if ((previousSummary.get(ticketTypeId) ?? 0) !== quantity) {
      return false;
    }
  }

  return true;
};
